import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';


export const MainLayoutRoutes: Routes = [

];
